import { render, staticRenderFns } from "./ProductStockTaking.vue?vue&type=template&id=3ae1df2b&scoped=true&"
import script from "./ProductStockTaking.vue?vue&type=script&lang=js&"
export * from "./ProductStockTaking.vue?vue&type=script&lang=js&"
import style0 from "./ProductStockTaking.vue?vue&type=style&index=0&id=3ae1df2b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae1df2b",
  null
  
)

export default component.exports